import { StoreState } from "./index";
import { StoreState as MemberTierCustomerState } from "./getMemberTierCustomer";
import { StoreState as IsLoadingState } from "./isLoading";

export function getMemberTierCustomer(
  state: StoreState
): MemberTierCustomerState {
  return state.memberTierCustomer;
}

export function getIsLoading(state: StoreState): IsLoadingState {
  return state.isLoading;
}
